export const NEW_USER_TOKEN = 'NEW_USER_TOKEN';
export const FETCH_USER_INFO = 'FETCH_USER_INFO';
export const FETCH_USER_INFO_DONE = 'FETCH_USER_INFO_DONE';
export const FETCH_USER_INFO_ERR = 'FETCH_USER_INFO_ERR';
export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_DONE = 'LOGIN_USER_DONE';
export const LOGIN_USER_ERR = 'LOGIN_USER_ERR';
export const LOGOUT_USER = 'LOGOUT_USER';
export const GET_USER_STATUS = 'GET_USER_STATUS';
export const GET_USER_STATUS_DONE = 'GET_USER_STATUS_DONE';
export const GET_USER_STATUS_ERR = 'GET_USER_STATUS_ERR';
export const GET_OWNER_STATUS = 'GET_OWNER_STATUS';
export const GET_OWNER_STATUS_DONE = 'GET_OWNER_STATUS_DONE';
export const GET_OWNER_STATUS_ERR = 'GET_OWNER_STATUS_ERR';
export const DELETE_USER = 'DELETE_USER';
export const DELETE_USER_DONE = 'DELETE_USER_DONE';
export const DELETE_USER_ERROR = 'DELETE_USER_ERROR';
export const REMOVE_USER_ERROR = 'REMOVE_USER_ERROR';
export const MEMBERSHIP_PAYMENT_FAILED_MODAL_VIEWED = 'MEMBERSHIP_PAYMENT_FAILED_MODAL_VIEWED';
export const GET_NEW_USER_STATUS = 'GET_NEW_USER_STATUS';
export const HERO_FILL_ACTIVATED = 'HERO_FILL_ACTIVATED';
export const NEW_ANONYMOUS_TOKEN = 'NEW_ANONYMOUS_TOKEN';
export const SELECT_HERO_ACCOUNT = 'SELECT_HERO_ACCOUNT';
//# sourceMappingURL=actionTypes.js.map